import { Layout, Skeleton, theme } from "antd";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import HeaderView from "./layout/header";
import Sidebar from "./layout/sidebar";
import { Wrapper } from "./style";
import { TableLoading } from "../components/table-animation";
import { BorderFilter } from "../config";
import { Admins } from "../routers/admin";
import { Users } from "../routers/user";

const { Content } = Layout;

const Page = (props) => {
  const { user, setData } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const [reloadPage, setReloadPage] = useState(true);
  const [loading, setLoading] = useState(true);
  const [isSidebarMinimized, setIsSidebarMinimized] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleLogout = () => {
    setData({});
    navigate("/login");
  };

  useEffect(() => {
    if (Object.keys(user)?.length === 0) {
      handleLogout();
    }

    setLoading(false);

    window.addEventListener("storage", (e) => {
      if (e?.storageArea?.length === 0) {
        setData({});
        return navigate("/login");
      }

      if (user) {
        const menusName = (
            !Object.keys(user)?.includes("admin") ? Admins : Users
        )?.map((d) => `/${d?.path}`);

        navigate(
            menusName?.includes(`${location.pathname}`)
                ? window.location.pathname
                : `${menusName?.[0]}`
        );
      }
    });

    return () => {};
  }, []);

  useEffect(() => {
    if (window.innerWidth < 992) {
      document.body.setAttribute(
          "data-kt-app-sidebar-minimize",
          isSidebarMinimized ? "off" : "off"
      );
      document.body.setAttribute(
          "data-kt-drawer",
          isSidebarMinimized ? "on" : "off"
      );
    } else {
      document.body.setAttribute(
          "data-kt-app-sidebar-minimize",
          isSidebarMinimized ? "on" : "off"
      );
      document.body.setAttribute(
          "data-kt-drawer",
          isSidebarMinimized ? "off" : "off"
      );
    }
  }, [isSidebarMinimized]);

  useEffect(() => {
    const sidebar = document.getElementById("kt_app_sidebar");

    const applySidebarClasses = () => {
      if (window.innerWidth < 992) {
        sidebar?.classList.add("drawer", "drawer-start");
      } else {
        sidebar?.classList.remove("drawer", "drawer-start");
      }
    };

    applySidebarClasses();
    window.addEventListener("resize", applySidebarClasses);

    return () => {
      window.removeEventListener("resize", applySidebarClasses);
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarMinimized((prev) => {
      const newState = !prev;
      const sidebar = document.getElementById("kt_app_sidebar");
      const overlayId = "drawer-overlay";
      let overlay = document.getElementById(overlayId);
      console.log(window.innerWidth);

      if (window.innerWidth < 992) {
        if (newState) {
          sidebar?.classList.add("drawer-on");

          if (!overlay) {
            overlay = document.createElement("div");
            overlay.id = overlayId;
            overlay.className = "drawer-overlay";
            overlay.style.zIndex = "105";
            overlay.style.position = "fixed";
            overlay.style.top = "0";
            overlay.style.left = "0";
            overlay.style.width = "100vw";
            overlay.style.height = "100vh";
            overlay.style.background = "rgba(0, 0, 0, 0.5)";
            overlay.style.transition = "opacity 0.3s ease-in-out";

            document.body.appendChild(overlay);

            overlay.addEventListener("click", () => {
              setIsSidebarMinimized(false);
              sidebar?.classList.remove("drawer-on");
              overlay.remove();
            });
          }
        } else {
          sidebar?.classList.remove("drawer-on");
          overlay?.remove();
        }
      } else {
        if (newState) {
          sidebar?.classList.add("drawer-on");

          if (!overlay) {
            console.log("Not overlay !!!");
            overlay = document.createElement("div");
            overlay.id = overlayId;
            overlay.style.zIndex = "105";
            overlay.style.position = "fixed";
            overlay.style.top = "0";
            overlay.style.left = "0";
            overlay.style.width = "1000vw";
            overlay.style.height = "100vh";
            overlay.style.transition = "opacity 0.3s ease-in-out";

            document.body.appendChild(overlay);

            overlay.addEventListener("click", () => {
              overlay.remove();
            });
          }
        } else {
          sidebar?.classList.remove("drawer-on");
          overlay?.remove();
        }
      }

      return newState;
    });
  };

  return (
      <div
          className="app-page flex-column flex-column-fluid"
          id="kt_app_page"
          style={{ backgroundColor: "#F1F2F4" }}
      >
        <HeaderView
            collapsed={collapsed}
            user={user}
            location={location}
            setData={setData}
            className=""
            setCollapsed={setCollapsed}
            handleLogout={handleLogout}
            colorBgContainer={colorBgContainer}
            toggleSidebar={toggleSidebar}
        />

        <div className="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
          <Sidebar
              id="kt_app_sidebar"
              user={user}
              setUser={setData}
              type={user?.loginType}
              collapsed={collapsed}
              location={location}
              handleLogout={handleLogout}
              toggleSidebar={toggleSidebar}
          />

          <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
            <div className="d-flex flex-column flex-column-fluid">
              <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                  {reloadPage ? (
                      <Wrapper>
                        <Outlet />
                      </Wrapper>
                  ) : (
                      <>
                        <div
                            className="card mb-3 mt-4 px-3"
                            style={{ border: BorderFilter }}
                        >
                          <div className="card-header d-flex justify-content-between align-items-center">
                            <div className="card-title d-flex align-items-center">
                              <Skeleton.Input active />
                            </div>
                            <div className="card-toolbar">
                              <Skeleton.Button active />
                            </div>
                          </div>
                        </div>

                        <div className="card">
                          <div
                              style={{
                                padding: "0px 15px",
                                marginTop: "10px",
                              }}
                          >
                            <TableLoading
                                id="test-table"
                                columns={[1, 2, 3, 4, 5]}
                                checkBoxVal={true}
                                actions={[1, 2]}
                            />
                          </div>
                        </div>
                      </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Page;